export const SettingsService = {
  getSettings: async () => {
    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Return mock data that mirrors the unified frontend state
    return {
      general: {
        platformName: "Smart Cargo",
        defaultLanguage: "en",
        timeZone: "UTC+4 (Baku)",
        dateTimeFormat: "DD/MM/YYYY HH:mm",
      },
      user: {
        allowCourierRegistration: true,
        defaultCourierStatus: "pending",
      },
      delivery: {
        defaultPriority: "normal",
        trafficRouting: true,
        etaMode: "dynamic",
        maxRadius: "50",
      },
      notification: {
        systemNotifications: true,
        emailAlerts: true,
        paymentNotifications: true,
        deliveryAlerts: true,
      },
      security: {
        minPasswordLength: "8",
        sessionTimeout: "30",
        specialCharsRequired: true,
        twoFactorEnabled: false,
      },
      data: {
        retentionPeriod: "12",
        backupFrequency: "daily",
      },
      api: {
        openStreetMapConnected: true,
        trafficAPIEnabled: true,
        apiKey: "sk_live_••••••••••••••••",
      },
      fleet: {
        vehicleTracking: true,
        maintenanceAlerts: true,
      }
    };
  },

  updateSettings: async (payload) => {
    // Simulate network delay for API request
    await new Promise((resolve) => setTimeout(resolve, 800));

    console.log("Settings updated successfully via mock API:", payload);
    return { success: true };
  }
};
